// web fonts from https://www.pdftron.com/webfonts/v2/fonts.json
// that support bold, italic, and bold-italic
// and can be used in content editing
export default [
  'Arimo',
  'Caladea',
  'Carlito',
  'Cousine',
  'Liberation Serif',
  'Open Sans',
  'Roboto',
  'Roboto Mono',
  'Tinos',
];
